'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fad';
var iconName = 'user-shakespeare';
var width = 448;
var height = 512;
var aliases = [];
var unicode = 'e2c2';
var svgPathData = ['M96 336l0 16c0 17.7 14.3 32 32 32l192 0c17.7 0 32-14.3 32-32l0-16c0-17.7-14.3-32-32-32l-192 0c-17.7 0-32 14.3-32 32zm48-208l0 16c0 38.7 27.5 71 64 78.4l0-6.4c0-8.8 7.2-16 16-16s16 7.2 16 16l0 6.4c36.5-7.4 64-39.7 64-78.4l0-16c0-44.2-35.8-80-80-80s-80 35.8-80 80zm33.7 47.2c-4-7.9-.7-17.5 7.2-21.5l32-16c4.5-2.3 9.8-2.3 14.3 0l32 16c7.9 4 11.1 13.6 7.2 21.5s-13.6 11.1-21.5 7.2l-24.8-12.4-24.8 12.4c-7.9 4-17.5 .7-21.5-7.2z', 'M304 128c0-44.2-35.8-80-80-80s-80 35.8-80 80l0 16c0 38.7 27.5 71 64 78.4l0-6.4c0-8.8 7.2-16 16-16s16 7.2 16 16l0 6.4c36.5-7.4 64-39.7 64-78.4l0-16zM96 128C96 57.3 153.3 0 224 0S352 57.3 352 128l0 11.3c0 8.4 2.2 16.6 6.3 23.8L379 199.3c3.3 5.7 5 12.2 5 18.8 0 20.9-17 37.9-37.9 37.9L286 256c-18.4 10.2-39.5 16-62 16s-43.6-5.8-62-16l-60.1 0c-20.9 0-37.9-17-37.9-37.9 0-6.6 1.7-13.1 5-18.8l20.7-36.2c4.1-7.3 6.3-15.5 6.3-23.8L96 128zm135.2 9.7l32 16c7.9 4 11.1 13.6 7.2 21.5s-13.6 11.1-21.5 7.2l-24.8-12.4-24.8 12.4c-7.9 4-17.5 .7-21.5-7.2s-.7-17.5 7.2-21.5l32-16c4.5-2.3 9.8-2.3 14.3 0zM16 484.6c0-60 32.1-112.4 80-141.2l0 8.6c0 17.7 14.3 32 32 32l72 0 0 128-156.6 0C28.3 512 16 499.7 16 484.6zM248 512l0-128 72 0c17.7 0 32-14.3 32-32l0-8.6c47.9 28.8 80 81.2 80 141.2 0 15.1-12.3 27.4-27.4 27.4L248 512z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faUserShakespeare = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;